import React from 'react';
import { SkeletonContainer } from '../SkeletonContainer';
import './Table.scss';

export const TableSkeleton = () => {
  return (
    <div className="table-skeleton-container">
      <SkeletonContainer width={550} height={250}>
        <rect x={50} y={5} width={100} height={30} />
        <rect x={225} y={5} width={100} height={30} />
        <rect x={400} y={5} width={100} height={30} />
        <rect x={0} y={45} width={550} height={2} />
        <rect x={25} y={60} width={500} height={20} />
        <rect x={25} y={100} width={500} height={20} />
        <rect x={25} y={140} width={500} height={20} />
        <rect x={25} y={180} width={500} height={20} />
        <rect x={25} y={220} width={500} height={20} />
      </SkeletonContainer>
    </div>
  );
};
